/* Copyright (c) 2017 Backpack Health LLC */

/* global IS_ANDROID_BUILD */

import { connect } from 'react-redux';

import Login from './Login.controller';

import { selectors, actions as userActions } from '../../redux/ducks/user';
import { actions as sessionActions } from '../../redux/ducks/session';

import RouteNames from '../../appAuthorized/RouteNames';
import { navigateBack, navigateReplace, navigate } from '../../appAuthorized/redux/NavigationActions';

function mapStateToProps(state, routerProps) {
  const email = selectors.getEmail(state);
  return {
    email,
    startWithPassword: routerProps.location.pathname === RouteNames.loginpassword() && !!email,
    goBack: (IS_ANDROID_BUILD ? () => {
      navigateBack(RouteNames.introEnd());
    } : null),
    goToLogin: () => {
      navigateReplace(RouteNames.login());
    },
    goToSignup: () => {
      if (IS_ANDROID_BUILD) {
        navigate(RouteNames.intro());
      } else {
        navigate(RouteNames.signupIntro());
      }
    },
    goToPassword() {
      navigate(RouteNames.loginpassword());
    },
    goToForgotPassword: () => {
      navigate(RouteNames.forgotPassword());
    },
    goToMfaVerify: (duration) => {
      navigate(RouteNames.verify(duration));
    },
  };
}

function mapDispatchToProps(dispatch) {
  return {
    submitCredentials(credentials, callback) {
      dispatch(sessionActions.login(credentials, callback));
    },
    updateEmail(email) {
      dispatch(userActions.updateEmail(email));
    },
    updateUser(data) {
      dispatch(userActions.updateUser(data));
    },
    submitUserUpdate: (userData, callback) => {
      dispatch(userActions.submitUserUpdate(userData, callback));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
